import { useContext, useMemo } from "react";
import { AppContext } from "..";
import {
  __INTERNAL_APP_NAME__DECCAN,
  __INTERNAL_APP_NAME__PRAJAVANI,
} from "../contant";

function useInternalAppName() {
  const { appData } = useContext(AppContext);

  const [isAppPV, isAppDH] = useMemo(
    () => [
      appData?.__internal_app_name === __INTERNAL_APP_NAME__PRAJAVANI,
      appData?.__internal_app_name === __INTERNAL_APP_NAME__DECCAN,
    ],
    [appData?.__internal_app_name]
  );

  return { appName: appData?.__internal_app_name, isAppDH, isAppPV };
}

export default useInternalAppName;
